export default "__VITE_ASSET__Bnb7GyR2__"